/**
 * constants values that are not evironmental dependent
 */

export const CONSTANTS = {
  DAILY_INSIGHTS_CONTENT_TAG: 'content-daily-insights',
  HEAP_REQUEST_TIMEOUT: 2000,
  HTML_IFRAME_WIDTH: 2400,
  HTML_IFRAME_HEIGHT: 1350,
}
export const IMAGE_SOURCE_TYPE = {
  KIMERA: 'source_2',
  CONTENT_LAKE: 'source_1',
}
